import { html, render } from "lit-html";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
import { createRef, ref } from "lit-html/directives/ref";
import { determineTranslation } from "../../../utils/language.js";
import { ProgressBar } from "../../../common/progress-bar.js";
import "../../../common/progress-bar.js";
import { format } from '../../../utils/string.js';
import { Locale } from "../../../common/interfaces/locate.js";
import { IFreeShippingInfoContract } from "../interfaces/free-shipping-info-contract.js";

export class FreeShippingProgressBar extends HTMLElement {

    constructor() {
        super();
        this._labels = determineTranslation(this.translations);
    }

    /* #region Public */
    public setData(data: IFreeShippingInfoContract){
        this._freeShippingInfo = data;
        this._render();
    }
    /* #endregion */

    /* #region Translations */
    private translations: { [key:string]: {[key:string]: string} } = {
        [Locale.En]: {
            leftToGoal: "<strong>{0}</strong> left till free delivery",
            goalReached: "Free delivery",
        },
        [Locale.No]: {
            leftToGoal: "<strong>{0}</strong> igjen til fri frakt",
            goalReached: "Fri frakt",
        }
    };
    /* #endregion */

    /* #region Markup */
    private template = () => html`
        <div class="goal ${this._freeShippingInfo.progress === 1 ? 'reached' : 'in-progress' }">
            ${this._freeShippingInfo.progress === 1 ? html`
                <svg xmlns="http://www.w3.org/2000/svg" width="11.501" height="8.002" viewBox="0 0 11.501 8.002"><path id="check2" d="M13.854,3.646a.5.5,0,0,1,0,.708l-7,7a.5.5,0,0,1-.708,0l-3.5-3.5a.5.5,0,0,1,.708-.708L6.5,10.293l6.646-6.647a.5.5,0,0,1,.708,0Z" transform="translate(-2.499 -3.499)" fill="#75aa83"/></svg>
                <div class="text">${this._labels.goalReached}</div>
            ` : html`
                <div class="text">${unsafeHTML(format(this._labels.leftToGoal, this._freeShippingInfo.freeShippingRemainderStr))}</div>
            `}
        </div>
        <progress-bar ${ref(this._progressBar)}></progress-bar>
    `;
    /* #endregion */

    /* #region Private */
    private _progressBar = createRef<ProgressBar>();
    private _labels: { [key: string]:any };
    private _freeShippingInfo: IFreeShippingInfoContract;
    /* #endregion */

    private _render() {
        if(window.globalSettings && window.globalSettings.freeShippingMessageSettings && this._freeShippingInfo && this._freeShippingInfo.showNotification){
            render(this.template(), this);
            if (this._progressBar.value){
                this._progressBar.value.percent = this._freeShippingInfo.progress * 100;
            }
        } else {
            render(html``, this);
        }
    }

    //public connectedCallback() {}
}

customElements.define("free-shipping-progress-bar", FreeShippingProgressBar);